'use client'
import {
  context_default
} from "./chunk-DQAIQ2IF.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/context/root/provider.tsx
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var WbkConfigProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const locale = ((_a2 = props.router) == null ? void 0 : _a2.locale) || "en";
  const handlePush = (url) => {
    window.location.assign(url);
  };
  const handleReplace = (url) => {
    window.location.replace(url);
  };
  const search = useMemo(() => {
    if (typeof window === "undefined")
      return new URLSearchParams();
    return new URLSearchParams(window.location.search);
  }, []);
  const handleSetSearch = (search2, options) => {
    const searchParams = typeof window === "undefined" ? new URLSearchParams() : new URLSearchParams(window.location.search);
    for (const key in search2) {
      const value = search2[key];
      if (!value) {
        searchParams.delete(key);
        continue;
      }
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(key, v);
        });
      } else {
        searchParams.set(key, value);
      }
    }
    const target = `${window.location.pathname}?${searchParams.toString()}`;
    if (options == null ? void 0 : options.replace) {
      handleReplace(target);
    } else {
      handlePush(target);
    }
  };
  const handleSetLocale = (newLocale) => {
    const pathWithoutLocale = window.location.pathname.replace(`/${locale}`, "");
    window.history.pushState({}, "", `/${newLocale}${pathWithoutLocale}`);
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, props), {
        router: {
          Link: ((_b2 = props.router) == null ? void 0 : _b2.Link) || "a",
          push: ((_c = props.router) == null ? void 0 : _c.push) || handlePush,
          replace: ((_d = props.router) == null ? void 0 : _d.replace) || handleReplace,
          locale,
          dir: locale === "ar" ? "rtl" : "ltr",
          languages: props.i18n.languages,
          pathname: ((_e = props.router) == null ? void 0 : _e.pathname) || "",
          search: ((_f = props.router) == null ? void 0 : _f.search) || search,
          params: ((_g = props.router) == null ? void 0 : _g.params) || {},
          baseUrl: ((_h = props.router) == null ? void 0 : _h.baseUrl) || void 0,
          setSearch: ((_i = props.router) == null ? void 0 : _i.setSearch) || handleSetSearch,
          setLocale: ((_j = props.router) == null ? void 0 : _j.setLocale) || handleSetLocale
        },
        checkout: __spreadProps(__spreadValues({}, props.checkout), {
          requiredUserProps: ((_k = props.checkout) == null ? void 0 : _k.requiredUserProps) || [
            "dob",
            "gender",
            "country",
            "nationality",
            "city"
          ],
          sendTicketsTerms: !!((_l = props.checkout) == null ? void 0 : _l.sendTicketsTerms)
        }),
        logo: props.logo
      }),
      children
    }
  );
};

export {
  WbkConfigProvider
};
//# sourceMappingURL=chunk-A2O6IPMQ.mjs.map